import React, { useReducer, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import dayjs from "dayjs";

// Custom.
import { HeaderProps } from "../global";
import { getInitialState } from "./state";
import { reducer } from "@vocollege/app/dist/modules/VoHelpers";
import VoDatePickerField from "@vocollege/components/dist/VoPickerField/VoDatePickerField";
import VoTextField from "@vocollege/components/dist/VoTextField";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import DownloadExcelButton from "@vocollege/components/dist/DownloadExcelButton";

const Header: React.FC<HeaderProps> = (props) => {
  const { title, loading, onChange, fields = ["from", "to"], excel } = props;
  const [state, dispatch] = useReducer(reducer, getInitialState());

  // Methods.

  const isDisabled = () => {
    return !state.from || !state.to || state.from === "" || state.to === "";
  };

  const handleChange = (field: string, newValue: unknown) => {
    dispatch({ key: field, values: newValue });
  };

  const getFilename = (data: any, format?: string) => {
    const name: string[] = [];
    name.push(data?.filename || format || "statistics");
    if (fields.indexOf("from") > -1 && state.from) {
      name.push(state.from);
    }
    if (fields.indexOf("to") > -1 && state.to) {
      name.push(state.to);
    }
    return name.join("_");
  };

  // Effects.

  useEffect(() => {
    dispatch({
      values: {
        // from: "2010-01-01",
        // to: "2015-12-31",
        from: dayjs().subtract(3, "months").format("YYYY-MM-DD"),
        to: dayjs().format("YYYY-MM-DD"),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Typography component="h2" variant="h4">
            {title || I18n.get.statistics.labels.statistics}
          </Typography>
        </Grid>
        {fields.indexOf("from") > -1 && (
          <Grid item xs="auto">
            <VoDatePickerField
              label={I18n.get.misc.from}
              inputFormat="YYYY-MM-DD"
              size="small"
              value={state.from}
              onChange={(newValue: any) =>
                handleChange("from", newValue.format("YYYY-MM-DD"))
              }
              renderInput={(params: any) => (
                <VoTextField
                  {...params}
                  label={I18n.get.misc.from}
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                  sx={{ maxWidth: 150 }}
                />
              )}
            />
          </Grid>
        )}
        {fields.indexOf("to") > -1 && (
          <Grid item xs="auto">
            <VoDatePickerField
              label={I18n.get.misc.to}
              inputFormat="YYYY-MM-DD"
              size="small"
              value={state.to}
              onChange={(newValue: any) =>
                handleChange("to", newValue.format("YYYY-MM-DD"))
              }
              renderInput={(params: any) => (
                <VoTextField
                  {...params}
                  label={I18n.get.misc.to}
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                  sx={{ maxWidth: 150 }}
                />
              )}
            />
          </Grid>
        )}
        <Grid item xs="auto" sx={{ textAlign: "right" }}>
          <LoadingButton
            disabled={isDisabled()}
            disableElevation
            variant="contained"
            color="primary"
            onClick={() => onChange && onChange(state)}
            loading={loading}
            size="small">
            {I18n.get.actions.generate}
          </LoadingButton>
        </Grid>
      </Grid>

      {excel && (
        <DownloadExcelButton
          filename={getFilename(excel, "xlsx")}
          sheets={excel.sheets}
        />
      )}
    </Box>
  );
};

export default Header;
